import { Expose } from "class-transformer";

export class CreatePayrollDto {
  @Expose()
  userId: string;

  @Expose()
  payrollDate: Date;

  @Expose()
  deadlineDate?: Date | null;

  @Expose()
  notes?: string;
}
